import apiClient from "../common/apiClient";

export default class AssociateController {
    async Create(data, token) {
          try {
            return await apiClient.post("/associate", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Update(departmentId, data, token) {
            try {
            return await apiClient.put("/associate/" + departmentId, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Delete(id, token) {
        try {
            return await apiClient.delete("/associate/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async GetAllAssociate(token) {
        try {
            return await apiClient.get("/getAllAssociate", {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
}
